export const CLIENT_FIELDS = {
  ID: 'id',
  DOCUMENT_TYPE: 'documentType',
  DOCUMENT_NUMBER: 'documentNumber',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  DATE_OF_BIRTH: 'dateOfBirth',
  GENDER: 'gender',
  PHONE_NUMBER: 'phoneNumber',
  EMAIL: 'email',
  SOFTSEGUROS_ID: 'softsegurosId',
};